import React, { useState } from 'react'
import { connect } from 'react-redux'
import { httpClient } from '../../funcs'
import { notifyAboutError } from '../../methods/notifyUser'
import Popup from '../../components/Popup'
import TemplateFileUpload from '../../components/TemplateFileUpload'
import SelectTemplateView from '../Contracts/SelectTemplateView'
import 'pages/Styles/UIKit_v2.sass'
import 'pages/Styles/TemplatesV2.sass'
import './ConfigureTemplateAfterPaymentPopup.sass'

type Props = {
    onClose: () => void
    onTemplateSelected: (templateId: string) => void
    /** ai — настройка через ИИ; manual — настройка специалистом */
    mode?: 'ai' | 'manual'
    $store: any
    $commitToStore: (data: any) => void
}

let ConfigureTemplateAfterPaymentPopup: any = function ConfigureTemplateAfterPaymentPopup({
    onClose,
    onTemplateSelected,
    mode = 'ai',
    $store,
    $commitToStore
}: Props) {
    const isManual = mode === 'manual'
    const [selectedTemplate, setSelectedTemplate] = useState<any>(null)
    const [uploadedFile, setUploadedFile] = useState<File | null>(null)
    const [isUploading, setIsUploading] = useState(false)

    const handleTemplateSelect = (template: any) => {
        setSelectedTemplate(template)
    }

    const handleFileChange = (file: File | null) => {
        setUploadedFile(file)
        if (file) setSelectedTemplate(null) // Снимаем выбор шаблона если загружаем файл
    }

    const buildTemplateName = (file: File) => {
        const baseName = file.name.replace(/\.[^.]+$/, '').trim()
        return baseName || 'Шаблон без названия'
    }

    const handleSubmit = async () => {
        try {
            setIsUploading(true)

            if (!selectedTemplate && !uploadedFile) {
                notifyAboutError({ $store, $commitToStore }, new Error('Выберите шаблон или загрузите файл'))
                return
            }

            let templateId: string | null = null
            if (uploadedFile) {
                // Если загружен новый файл - создаем новый шаблон
                const formData = new FormData()
                formData.append('name', buildTemplateName(uploadedFile))
                formData.append('file', uploadedFile, uploadedFile.name)

                const { data } = await httpClient.post('/new-template', formData)
                templateId = data?._id || null
            } else if (selectedTemplate) {
                // Если выбран существующий шаблон
                templateId = selectedTemplate.id || selectedTemplate._id || null
            }

            if (!templateId) {
                throw new Error('Не удалось определить шаблон для настройки')
            }

            onTemplateSelected(templateId)
            onClose()
        } catch (error) {
            notifyAboutError({ $store, $commitToStore }, error)
        } finally {
            setIsUploading(false)
        }
    }

    const isFormValid = selectedTemplate !== null || uploadedFile !== null

    return (
        <Popup onClose={onClose}>
            <div className="configure-template-popup-content templates-add-popup ui-kit-v2">
                <div className="H3_21_v2">
                    Настройка шаблона
                </div>

                <div className="Body_16_v2_secondary">
                    {isManual
                        ? 'Перед оплатой укажите, какой шаблон нужно настроить. После оплаты с вами свяжется менеджер.'
                        : 'Перед оплатой укажите, какой шаблон нужно настроить. После оплаты мы запустим настройку через ИИ.'}
                </div>

                {/* Выбор существующего шаблона */}
                <div>
                    <div className="Subtitle_16" style={{ marginBottom: '8px' }}>
                        Выберите существующий шаблон
                    </div>
                    <SelectTemplateView
                        selectedTemplate={selectedTemplate}
                        didSelectTemplate={handleTemplateSelect}
                    />
                </div>

                <div className="divider" />

                {/* Или загрузка нового */}
                <div>
                    <div className="Subtitle_16" style={{ marginBottom: '8px' }}>
                        Или загрузите новый шаблон
                    </div>
                    <TemplateFileUpload
                        file={uploadedFile}
                        onFileChange={handleFileChange}
                        compact
                        titleWhenEmpty="Выбрать файл"
                        uploadButtonText="Выбрать файл"
                        subtitleWhenEmpty=""
                    />
                </div>

                {/* Кнопки действий */}
                <div className="buttons-container-v2">
                    <button
                        className="action-button secondary"
                        onClick={onClose}
                        disabled={isUploading}
                    >
                        <span className="button-text">Отмена</span>
                    </button>
                    <button
                        className="action-button primary"
                        onClick={handleSubmit}
                        disabled={!isFormValid || isUploading}
                    >
                        <span className="button-text">
                            {isUploading ? 'Отправка...' : 'Отправить'}
                        </span>
                    </button>
                </div>
            </div>
        </Popup>
    )
}

ConfigureTemplateAfterPaymentPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(ConfigureTemplateAfterPaymentPopup)

export default ConfigureTemplateAfterPaymentPopup

